<template>
  <div class="geoproceso-form form-section">
    <!-- MODO DE SELECCIÓN -->
    <GeoprocesoSelectorModo v-model="otrasCapas" @input="onModeChange" />

    <!-- SELECCIÓN DE CAPA (Si aplica) -->
    <GeoprocesoSelectorCapa 
      v-model="capaOtrasSeleccionada"
      :otrasCapas="otrasCapas"
      :tipoInfluencia="'Poligonal'"
      :dissolve="dissolve"
      @selection-complete="onSelectionComplete"
    />

    <!-- HERRAMIENTAS DE DIBUJO (Si aplica) -->
    <div v-if="!otrasCapas">
      <label>Dibujar Rectángulo <span style="font-weight:normal;">o</span> Dibujar Polígono</label>
      <div class="draw-buttons">
        <button class="draw-btn" title="Dibujar rectángulo" @click="drawRect">▭</button>
        <button class="draw-btn" title="Dibujar polígono" @click="drawPolygon">⬟</button>
      </div>
    </div>

    <GeoprocesoOpcionesGenerales
      :capas.sync="capas"
      :metodo.sync="metodo"
      :capasSeleccionadas.sync="capasSeleccionadas"
      :dissolve.sync="dissolve"
    />
  </div>
</template>

<script>
import GeoprocesoBaseMixin from '@/components/mapTools/geoprocessings/mixins/GeoprocesoBaseMixin';
import GeoprocesoOpcionesGenerales from '@/components/mapTools/geoprocessings/forms/GeoprocesoOpcionesGenerales';
import GeoprocesoSelectorModo from '@/components/mapTools/geoprocessings/forms/GeoprocesoSelectorModo';
import GeoprocesoSelectorCapa from '@/components/mapTools/geoprocessings/forms/GeoprocesoSelectorCapa';

export default {
  name: 'InfluenciaPoligonalForm',
  components: { GeoprocesoOpcionesGenerales, GeoprocesoSelectorModo, GeoprocesoSelectorCapa },
  mixins: [GeoprocesoBaseMixin],
  data() {
    return {
      capaOtrasSeleccionada: '',
      seleccionInfo: null,
    };
  },
  methods: {
    drawRect() {
      this.$emit('changeDrawType', { name: 'Rectángulo', code: 'Box' });
    },
    drawPolygon() {
      this.$emit('changeDrawType', { name: 'Polígono', code: 'Polygon' });
    },
    currentPayload() {
      return {
        ...this.getCommonPayload(),
        capaOtrasSeleccionada: this.capaOtrasSeleccionada,
        seleccionInfo: this.seleccionInfo,
      };
    },
    onSelectionComplete(data) {
      this.seleccionInfo = data;
      this.emitState();
    },
  },
};
</script>

<style src="./_geoproceso-forms.css"></style>
<style scoped>
.draw-buttons {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  margin-bottom: 8px;
}
.draw-btn {
  width: 38px;
  height: 38px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background: #333;
  color: #fff;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
}
.draw-btn:hover { background: #444; }
.draw-btn:active { background: #555; transform: scale(0.97); }
</style>
